var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFallbackAvatar = function SvgFallbackAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "fallback-avatar_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fallback-avatar_svg__st1{fill:#8b9c8f}")), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#085239"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 27c0 1.5-1 2-2.5 2h-13c-1.6 0-2.5-.5-2.5-2 0-4 4.5-7 9-7s9 3 9 7zM24 15c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4z",
    className: "fallback-avatar_svg__st1"
  })));
};
export default SvgFallbackAvatar;